import { SEARCH_PARAMS_CHANGED } from '@web-platform/shared-universal-constants/src/userSearch';

import {
  SELECTED_LEG_ID_BY_STEP_INDEX_CHANGED,
  SELECTED_LEG_ID_BY_STEP_INDEX_REMOVED,
  SHOW_STEP_SELECTION_LOADING_CHANGED,
  SELECTED_LEG_ID_BY_STEP_INDEX_RESET,
} from '../../../../../actions/singleLegResults';

import type {
  Action,
  SelectedLegIdByStepIndexChangedAction,
  SelectedLegIdByStepIndexRemovedAction,
  SelectedLegIdByStepIndexResetAction,
  ShowStepSelectionLoadingChangedAction,
} from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { SingleLegResultsState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/singleLegResults/singleLegResults';

export const INITIAL_STATE: SingleLegResultsState = {
  selectedLegIdsByStepIndex: {},
  showStepSelectionLoadingState: false,
};

export const singleLegResultsReducer = (
  state: SingleLegResultsState = INITIAL_STATE,
  action:
    | Action
    | SelectedLegIdByStepIndexChangedAction
    | SelectedLegIdByStepIndexRemovedAction
    | SelectedLegIdByStepIndexResetAction
    | ShowStepSelectionLoadingChangedAction,
) => {
  switch (action.type) {
    case SELECTED_LEG_ID_BY_STEP_INDEX_CHANGED:
      return {
        ...state,
        selectedLegIdsByStepIndex: {
          ...state.selectedLegIdsByStepIndex,
          [action.payload.stepIndex]: action.payload.legId,
        },
        showStepSelectionLoadingState: true,
      };

    case SELECTED_LEG_ID_BY_STEP_INDEX_REMOVED: {
      const { [action.payload.stepIndex]: _, ...restSelectedLegIdsByStepIndex } =
        state.selectedLegIdsByStepIndex;
      return {
        ...state,
        selectedLegIdsByStepIndex: restSelectedLegIdsByStepIndex,
        showStepSelectionLoadingState: true,
      };
    }

    case SHOW_STEP_SELECTION_LOADING_CHANGED: {
      return {
        ...state,
        showStepSelectionLoadingState: action.payload,
      };
    }

    case SELECTED_LEG_ID_BY_STEP_INDEX_RESET:
      return {
        ...state,
        selectedLegIdsByStepIndex: {},
        showStepSelectionLoadingState: false,
      };

    case SEARCH_PARAMS_CHANGED:
      return INITIAL_STATE;

    default:
      return state;
  }
};
